import { ReactNode } from 'react';

import '@pelckmans/elementis/secunda-light.css';

export default function ThemeSecunda({ children }: { children: ReactNode }) {
  return children;
}
